import { Clock, Send, CheckCircle, XCircle } from "lucide-react";

interface StatusBadgeProps {
  status: "draft" | "scheduled" | "sending" | "sent" | "cancelled";
  className?: string;
}

export function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const statusConfig = {
    draft: {
      icon: <Clock size={14} />,
      label: "Draft",
      bgColor: "bg-gray-100",
      textColor: "text-gray-700",
      dotColor: "bg-gray-400",
    },
    scheduled: {
      icon: <Clock size={14} />,
      label: "Scheduled",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
      dotColor: "bg-blue-500",
    },
    sending: {
      icon: <Send size={14} />,
      label: "Sending",
      bgColor: "bg-amber-50",
      textColor: "text-amber-700",
      dotColor: "bg-amber-500",
    },
    sent: {
      icon: <CheckCircle size={14} />,
      label: "Sent",
      bgColor: "bg-green-50",
      textColor: "text-green-700",
      dotColor: "bg-green-500",
    },
    cancelled: {
      icon: <XCircle size={14} />,
      label: "Cancelled",
      bgColor: "bg-red-50",
      textColor: "text-red-700",
      dotColor: "bg-red-500",
    },
  };

  const config = statusConfig[status];

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}>
      <span className={`w-2 h-2 rounded-full ${config.dotColor}`} />
      {config.icon}
      <span>{config.label}</span>
    </div>
  );
}
